import React from 'react';
export function HeroSection() {
  return <section className="relative pt-24 pb-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center" data-id="element-107">
      <div className="hero-animate" data-id="element-108">
        <h1 className="text-4xl md:text-6xl font-extrabold text-white tracking-tight mb-6 leading-tight" data-id="element-109">
          ¿Tu empresa depende{' '}
          <span className="text-amber-500" data-id="element-110">100% de vos</span> para funcionar?
        </h1>

        <p className="text-xl md:text-2xl text-slate-300 max-w-4xl mx-auto mb-12 leading-relaxed" data-id="element-111">
          Descubrí el sistema exacto que usan las empresas que escalan para
          dejar de apagar incendios y empezar a construir una organización que
          trabaje sin que estés en todo
        </p>

        <div className="relative max-w-3xl mx-auto mt-12" data-id="element-112">
          <div className="absolute inset-0 bg-blue-500/20 blur-[60px] rounded-full pointer-events-none" aria-hidden="true" data-id="element-113" />

          <img src="https://cdn.magicpatterns.com/uploads/5q59V8L4m6ADUSNGRFBC9d/ChatGPT_Image_10_mar_2026,_00_45_48.png" alt="Mega Pack Gestión Organizacional - 6 tomos completos de gestión empresarial para PyMEs" width={662} height={662} fetchPriority="high" decoding="async" className="relative z-10 w-full h-auto rounded-xl shadow-2xl shadow-black/50 border border-slate-800/50" data-id="element-114" />
        </div>
      </div>
    </section>;
}